import { Box, Typography } from "@mui/material";
import { useState } from "react";

import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import LoadingIcon from "../../../../components/LoadingIcon";
import { logos } from "../../environment/icons/iconExport";
import Guideline from "../components/Guideline";
import GuidelineStep from "../components/GuidelineStep";
import GuidelineStepByStep from "../components/GuidelineStepByStep";
import PanoraysConnectForm from "./PanoraysConnectForm";

const Panorays = () => {
  const [guideMode] = useState(false);
  const { isIntegrated, isIntegratedLoading } = useIsIntegrated("panorays");

  return (
    <Guideline
      title={
        !isIntegrated
          ? "Once integrated, the Breeze platform will automatically ingest data from Panorays."
          : ""
      }
      image={logos.PanoraysLogo}
      iconBorderRadius={0}
      name="Panorays"
      content={
        isIntegratedLoading ? (
          <LoadingIcon size={25} />
        ) : isIntegrated && !guideMode ? (
          <Box>
            <Typography variant={"h4"}>Panorays is integrated!</Typography>
          </Box>
        ) : (
          <div>
            <Box mb="20px">
              <Typography variant="h6">How to connect Panorays</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              <GuidelineStepByStep>
                <GuidelineStep title="Connect to Breeze">
                  <Typography variant="body2">
                    Copy the API token and paste it in the form below.
                  </Typography>
                  <PanoraysConnectForm />
                </GuidelineStep>
              </GuidelineStepByStep>
            </Box>
          </div>
        )
      }
    />
  );
};

export default Panorays;
